import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../../components/base/Icon";
import { OverdueInvoiceItem } from "../../models/AdminDashboardModel";

type Props = {
    items?: OverdueInvoiceItem[]
}

function OverdueInvoicesWidget(props: Props) {
    const items = props.items ?? [];
    const totalOverdue = items.reduce((s, x) => s + (x.total || 0), 0);

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Overdue Invoices</h3>
                    <div className="widget-subtitle">{items.length} unpaid · ${totalOverdue.toLocaleString()} outstanding</div>
                </div>
            </div>
            <div className="card-body pt-3" style={{ maxHeight: 420, overflowY: "auto" }}>
                {items.length === 0 && (
                    <div className="text-center text-gray-500 py-8">
                        <Icon icon="file-invoice-dollar" type="thin" size={48} className="text-gray-400 mb-3" />
                        <div>No overdue invoices</div>
                    </div>
                )}
                {items.map(it => (
                    <Link key={it.id} to={`/crm/jobs/details/${it.jobId}`} className="invoice-row d-flex align-items-center text-decoration-none">
                        <div className="flex-grow-1 min-w-0 pe-2">
                            <div className="fw-bold text-gray-900 text-truncate">#{it.invoiceNumber} — {it.billingName || "—"}</div>
                            <div className="text-gray-500 fs-7">${it.total.toLocaleString()}</div>
                        </div>
                        <span className="badge-overdue">{it.daysOverdue}d overdue</span>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default OverdueInvoicesWidget;
